import { z } from 'zod';

import { ModalSessionSearchResponseSchema } from './session';

/** Resposta da BUSCA de hotel (#3399): a mesma vista da busca mais `total`, a
 *  contagem do conjunto INTEIRO da busca (`searchHotelMetadata`). `offers`
 *  aqui é a lista RESUMIDA do fornecedor (a busca inicial roda com
 *  `showResumeHotels`), então sem este número quem lê a resposta conta o
 *  recorte como se fosse a busca — a fala dizia "Separei 6" para um painel de
 *  101. Opcional porque a contagem é uma leitura à parte, fail-soft, e é pulada
 *  na busca ancorada num hotel (a contagem não sabe filtrar por hotel). Evolução
 *  ADITIVA: a resposta genérica acima segue estrita, e um consumidor antigo
 *  rejeita este campo — os consumidores sobem antes ou junto do emissor. */
export const ModalSessionHotelSearchResponseSchema = ModalSessionSearchResponseSchema.extend({
  total: z.number().int().nonnegative().optional(),
  /** O fornecedor AINDA monta a lista cheia desta busca: `offers` é o que já
   *  existia quando o orçamento de espera pedido (`Prefer: wait=<s>`) venceu —
   *  pode ser nenhuma. Quem recebe continua pela leitura paginada da MESMA
   *  sessão (`refine-search`), nunca lê isto como vazio. Só sai para quem pediu
   *  o orçamento, então um consumidor que não o pede nunca o vê. */
  processing: z.literal(true).optional(),
}).strict();
export type ModalSessionHotelSearchResponse = z.infer<typeof ModalSessionHotelSearchResponseSchema>;
